import { createSelector } from '@reduxjs/toolkit'
import { filteredGroupsSelector } from '@/store/servicesSlice'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { cartSlice } from '..'

type MinQtyErr = {
  type: 'minQty'
  minQty: number
}

type TicketError = {
  groupId: number
  serviceId: number
} & MinQtyErr

export const ticketPageErrorsSelector = createSelector(
  [cartSlice.selectors.cartReservations, filteredGroupsSelector],
  (cartReservations, groups): TicketError[] => {
    const errors: TicketError[] = []
    const reservation = cartReservations.find(
      (r) => r.spotType === null && r.spotName === null
    )
    if (!reservation || groups.length === 0) {
      return errors
    }

    const boughServicesMap = new Map<number, number>()

    Object.entries(reservation.boughtServices).forEach((entry) => {
      const [key, boughtServices] = entry
      const serviceId = Number(key)

      boughServicesMap.set(serviceId, getBoughtServicesTotal(boughtServices))
    })

    groups.forEach((group) => {
      group.services.forEach((service) => {
        const boughtAmout = boughServicesMap.get(service.serviceId)
        if (
          service.minimumQuantity > 0 &&
          (typeof boughtAmout === 'undefined' ||
            boughtAmout < service.minimumQuantity)
        ) {
          errors.push({
            groupId: service.serviceGroupId,
            minQty: service.minimumQuantity,
            serviceId: service.serviceId,
            type: 'minQty',
          })
        }
      })
    })

    return errors
  }
)
